export const transitionDelay = 300;
"sa8p7x1";
export const languagePicker = "l11ig4mh";
export const menuWrapper = "mcr41ct";
export const backdrop = "b1g47y1q";
export const closeMenu = "cp2416w";
export const logoutButton = "l1qjtrih";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");